import React, { useState, useCallback } from 'react'
import BirlExercise from 'models/birl/exercise'
import updateModelMember from 'braindamage/api/updateModelMember'
import { useQueryClient, useMutation } from '@tanstack/react-query'
import update from 'immutability-helper'


const WeightMapWeightInput = ({ weightMap, setWeightMap, index }) => {
  const onChange = useCallback((event) => {
    const updatedWeightMap = update(weightMap, { [index-1]: { weight: { $set: parseFloat(event.target.value) }}});
    setWeightMap(updatedWeightMap);
  })

  return <input type="number"
                inputMode="numeric"
                className="text-xs text-center"
                step="0.1"
                tabIndex={ index }
                value={ weightMap[index-1]?.weight }
                onFocus={(e) => {
                  const target = e.target
                  setTimeout(() => target.select(), 0)
                }}
                onChange={ onChange }
         />
}

export default ({ birlExercise }) => {
  const [isEditing, setIsEditing] = useState(birlExercise.isMissingWeightMap)
  const [weightMap, setWeightMap] = useState(birlExercise.withZerosWeightMap())

  const queryClient = useQueryClient();

  const updateBirlExercise = useMutation({
    mutationFn: async (params) => {
      return updateModelMember(`/api/birl/exercises/${birlExercise.id}`, BirlExercise, { ['birlExerciseAttributes']: params })
    },
    onSuccess: async (data) => {
      queryClient.invalidateQueries({ queryKey: ['birl_exercise', birlExercise.id] })
      queryClient.setQueryData(['birl_exercise', birlExercise.id], data)
      queryClient.refetchQueries(['birl_exercise', birlExercise.id])
    },
    onSettled: async (data) => {
      // console.log("onSettled", data);
    },
    onError: async (data) => {
      console.log("onError", data);
    }
  })

  const save = useCallback(() => {
    updateBirlExercise.mutate({ weightMap }, {
      onSettled: () => {
        setIsEditing(false)
      }
    })
  })

  const edit = useCallback(() => {
    setIsEditing(true)
  })

  const cancelEdit = useCallback(() => {
    setIsEditing(false)
  })

  return <>
           <div className="mb-d">
             {
               birlExercise.isMissingWeightMap ?
                 <div className="orange-transparent-box py-2 mb-d">
                   <div className="text-center text-xl"> Set Initial Weights </div>
                 </div> :
                 null
             }
             {
               !isEditing &&
                 <div className="text-sm text-gray-800"> Weight Map </div>
             }
             <div className="frow flex-1">
               {
                 birlExercise.weightMap.map((weightMapItem) => {
                   return <div key={ weightMapItem.index } className="flex-1 fcol items-center justify-center">
                            <div className={ clsx('rounded-top darkest-gray-transparent-box text-center', { 'text-lg py-2': isEditing, 'text-sm': !isEditing })} style={{ width: '100%' }}>
                              {
                                weightMapItem.index
                              }
                              <div className="text-2xs text-center text-gray-400" style={{ width: '100%' }}>
                                {
                                  weightMapItem.range
                                }
                              </div>
                            </div>

                            {
                              isEditing ?
                                <WeightMapWeightInput
                                  weightMap={ weightMap }
                                  setWeightMap={ setWeightMap }
                                  index={ weightMapItem.index } /> :

                              <div className={ clsx("rounded-bottom gray-transparent-box text-center", { 'text-3xl': isEditing, 'text-lg': !isEditing }) } style={{ width: '100%' }}>
                                {
                                  isNaN(weightMapItem.weight) ? '?' : `${weightMapItem.weight}kg`
                                }
                              </div>
                            }
                          </div>
                 })
               }
               {
                 isEditing ?
                   null :
                   <div className="pl-d frow items-center">
                     <div className="btn btn-icon btn-secondary" onClick={ edit }>
                       <i className="ph ph-pencil" />
                     </div>
                   </div>
               }
             </div>
           </div>
           { isEditing ? <div className="btn btn-lg btn-primary btn-block" onClick={ save }> Save </div> : null }
           { (isEditing && !birlExercise.isMissingWeightMap) ? <div className="text-gray-200 text-center mt-1" onClick={ cancelEdit }> Cancel </div> : null }
         </>
};
